// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__rAcLk","approved":"Status_approved__25wwl","rejected":"Status_rejected__CTDmv","expired":"Status_expired__1MpJH","label":"Status_label__1e-YI"};